// ─── GBCOSPACK — useQuotationPdfDownload ─────────────────────────────────────
// Shared hook for PQ / FO detail pages. Wraps downloadQuotationPdf with a
// loading state and a double-click guard so concurrent PDF generations cannot
// be triggered for the same document.

import { useCallback, useRef, useState } from 'react';
import type { QuotationDocumentData } from '@/quotation/document/types';
import { downloadQuotationPdf } from './downloadQuotationPdf';

export interface QuotationPdfDownloadState {
  downloading: boolean;
  failed: boolean;
  download: (data: QuotationDocumentData) => void;
}

export function useQuotationPdfDownload(): QuotationPdfDownloadState {
  const [downloading, setDownloading] = useState(false);
  const [failed, setFailed] = useState(false);
  const inFlight = useRef(false);

  const download = useCallback((data: QuotationDocumentData) => {
    if (inFlight.current) return;
    inFlight.current = true;
    setDownloading(true);
    setFailed(false);
    downloadQuotationPdf(data)
      .catch(() => {
        setFailed(true);
      })
      .finally(() => {
        inFlight.current = false;
        setDownloading(false);
      });
  }, []);

  return { downloading, failed, download };
}